export default "__VITE_ASSET__60bf1501__"